import { get } from "../client";
import { CONTENT } from "../routes";

export default {
  get_content: async () => await get(CONTENT),
};
